import { render, staticRenderFns } from "./indexHomeAnnotation.vue?vue&type=template&id=489de549&scoped=true&"
import script from "./indexHomeAnnotation.vue?vue&type=script&lang=js&"
export * from "./indexHomeAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./indexHomeAnnotation.vue?vue&type=style&index=0&id=489de549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489de549",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VRow,VSheet})
